import React, { useMemo, useState } from "react";
import { API_BASE } from "../config";

import {
  LineChart,
  Line,
  CartesianGrid,
  XAxis,
  YAxis,
  Tooltip,
  ResponsiveContainer,
  PieChart,
  Pie,
  Cell,
  Legend,
} from "recharts";

import { UtilisateursAdmin } from "./Utilisateurs.js";
import { CollectivitesAdmin } from "./CollectivitesAdmin.js";
import { MedecinsAdmin } from "./MedecinsAdmin.js";
import { RendezVousAdmin } from "./RendezVousAdmin.js";
import { ParametresAdmin } from "./ParametresAdmin.js";
import { UsagersAdmin } from "./UsagersAdmin.js";
import { ArchivesAdmin } from "./ArchivesAdmin.js";

import "../styles/DashboardAdmin.css";

const Icons = {
  usager: (
    <svg viewBox="0 0 24 24" aria-hidden="true">
      <path d="M12 12c2.7 0 4.8-2.1 4.8-4.8S14.7 2.4 12 2.4 7.2 4.5 7.2 7.2 9.3 12 12 12zm0 2.4c-3.2 0-9.6 1.6-9.6 4.8v2.4h19.2v-2.4c0-3.2-6.4-4.8-9.6-4.8z" />
    </svg>
  ),
  overview: (
    <svg viewBox="0 0 24 24" aria-hidden="true">
      <path d="M3 13h8V3H3v10zm10 8h8V11h-8v10zM3 21h8v-6H3v6zm10-18v6h8V3h-8z" />
    </svg>
  ),
  users: (
    <svg viewBox="0 0 24 24" aria-hidden="true">
      <path d="M16 11c1.66 0 2.99-1.34 2.99-3S17.66 5 16 5s-3 1.34-3 3 1.34 3 3 3zM8 11c1.66 0 2.99-1.34 2.99-3S9.66 5 8 5 5 6.34 5 8s1.34 3 3 3zm0 2c-2.33 0-7 1.17-7 3.5V19h14v-2.5C15 14.17 10.33 13 8 13zm8 0c-.29 0-.62.02-.97.05 1.16.84 1.97 1.97 1.97 3.45V19h6v-2.5c0-2.33-4.67-3.5-7-3.5z" />
    </svg>
  ),
  building: (
    <svg viewBox="0 0 24 24" aria-hidden="true">
      <path d="M12 2 2 7v15h20V7L12 2zm8 18h-3v-6h-4v6H4V9l8-4 8 4v11z" />
    </svg>
  ),
  doctor: (
    <svg viewBox="0 0 24 24" aria-hidden="true">
      <path d="M19 3h-1V1h-2v2H8V1H6v2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V8h14v11z" />
    </svg>
  ),
  calendar: (
    <svg viewBox="0 0 24 24" aria-hidden="true">
      <path d="M7 2v2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2h-2V2h-2v2H9V2H7zm12 18H5V9h14v11z" />
    </svg>
  ),
  /*
  export: (
    <svg viewBox="0 0 24 24" aria-hidden="true">
      <path d="M5 20h14v-2H5v2zM12 2l-5.5 5.5 1.42 1.42L11 6.84V16h2V6.84l3.08 3.08 1.42-1.42L12 2z" />
    </svg>
  ),
  */
  archive: (
    <svg viewBox="0 0 24 24" aria-hidden="true">
      <path d="M20 2H4c-1.1 0-2 .9-2 2v3.01c0 .72.43 1.34 1 1.72V20c0 1.1 1.1 2 2 2h14c.9 0 2-.9 2-2V8.72c.57-.38 1-1 1-1.72V4c0-1.1-.9-2-2-2zm-5 12H9v-2h6v2zm5-7H4V4h16v3z" />
    </svg>
  ),
  settings: (
    <svg viewBox="0 0 24 24" aria-hidden="true">
      <path d="M19.14 12.94c.04-.31.06-.63.06-.94s-.02-.63-.06-.94l2.03-1.58a.5.5 0 0 0 .12-.64l-1.92-3.32a.5.5 0 0 0-.61-.22l-2.39.96a7.007 7.007 0 0 0-1.63-.94l-.36-2.54A.5.5 0 0 0 13.88 2h-3.76a.5.5 0 0 0-.49.42l-.36 2.54c-.6.24-1.16.56-1.63.94l-2.39-.96a.5.5 0 0 0-.61.22L2.72 8.48a.5.5 0 0 0 .12.64l2.03 1.58c-.04.31-.06.63-.06.94s.02.63.06.94l-2.03 1.58a.5.5 0 0 0-.12.64l1.92 3.32c.14.24.43.34.69.22l2.39-.96c.47.38 1.03.7 1.63.94l.36 2.54c.04.26.26.42.49.42h3.76c.26 0 .45-.16.49-.42l.36-2.54c.6-.24 1.16-.56 1.63-.94l2.39.96c.26.12.55.02.69-.22l1.92-3.32a.5.5 0 0 0-.12-.64l-2.03-1.58zM12 15.5A3.5 3.5 0 1 1 12 8a3.5 3.5 0 0 1 0 7.5z" />
    </svg>
  ),
  logout: (
    <svg viewBox="0 0 24 24" aria-hidden="true">
      <path d="M10 17l1.41-1.41L8.83 13H20v-2H8.83l2.58-2.59L10 7l-5 5 5 5zM4 4h6V2H4c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h6v-2H4V4z" />
    </svg>
  ),
};

const DashboardAdmin = ({ user, onLogout }) => {
  const menuItems = useMemo(
    () => [
      { key: "overview", label: "Vue globale", icon: Icons.overview },
      { key: "utilisateurs", label: "Utilisateurs", icon: Icons.users },
      { key: "collectivites", label: "Collectivités", icon: Icons.building },
      { key: "medecins", label: "Médecins", icon: Icons.doctor },
      { key: "rendezvous", label: "Rendez-vous", icon: Icons.calendar },
      { key: "usagers",    label: "Usagers",      icon: Icons.usager   },
      { key: "archives",   label: "Archives",     icon: Icons.archive  },
      { key: "settings",   label: "Paramètres",   icon: Icons.settings },
    ],
    []
  );

  const [confirmLogout, setConfirmLogout] = useState(false);
  const [active, setActive] = useState("overview");
  const [sidebarOpen, setSidebarOpen] = useState(false);

  const pageTitle =
    (k) => menuItems.find((i) => i.key === k)?.label || "Espace Admin";

  const closeSidebar = () => setSidebarOpen(false);

  const handleSelect = (k) => {
    setActive(k);
    closeSidebar();
  };


  return (
    <div className="adminApp">
      <button
        className={`adminOverlay ${sidebarOpen ? "isOpen" : ""}`}
        aria-label="Fermer le menu"
        onClick={closeSidebar}
      />

      <aside className={`adminSidebar ${sidebarOpen ? "isOpen" : ""}`}>
        <div className="adminBrand">
          <div className="adminLogo">FD</div>
          <div className="adminBrandText">
            <div className="adminBrandTitle">FormiDoc</div>
            <div className="adminBrandSub">Espace Super Admin</div>
          </div>
        </div>

        <div className="adminProfile">
          <div className="adminProfileTop">
            <div className="adminProfileLabel">Connecté en tant que</div>
            <span className="adminRolePill">Admin</span>
          </div>
          <div className="adminEmail">{user?.email}</div>
        </div>

        <nav className="adminNav">
          {menuItems.map((item) => (
            <button
              key={item.key}
              type="button"
              className={`adminNavItem ${active === item.key ? "active" : ""}`}
              onClick={() => handleSelect(item.key)}
            >
              <span className="adminNavIcon">{item.icon}</span>
              <span className="adminNavText">{item.label}</span>
            </button>
          ))}
        </nav>

        <div className="adminSidebarFooter">
          <button className="adminLogout" onClick={() => setConfirmLogout(true)}>
            <span className="adminLogoutIcon">{Icons.logout}</span>
            <span>Se déconnecter</span>
          </button>

          
        </div>
      </aside>

      <main className="adminMain">
        <header className="adminTopbar">
          <div className="adminTopbarLeft">
            <button
              className="adminBurger"
              aria-label="Ouvrir le menu"
              onClick={() => setSidebarOpen(true)}
            >
              <span />
              <span />
              <span />
            </button>

            <div>
              <div className="adminTitle">{pageTitle(active)}</div>
              <div className="adminSubtitle"></div>
            </div>
          </div>

          <div className="adminTopbarRight">
            <span className="adminChip">Admin</span>
          </div>
        </header>

        <section className="adminContent">
          {active === "overview" && (
            <AdminOverview user={user} setActive={setActive} />
          )}

          {active === "utilisateurs" && <UtilisateursAdmin user={user} />}

          {active === "collectivites" && <CollectivitesAdmin user={user} />}

          {active === "medecins" && <MedecinsAdmin user={user} />}

          {active === "rendezvous" && <RendezVousAdmin user={user} />}

          {active === "usagers" && <UsagersAdmin user={user} />}

          {active === "archives" && <ArchivesAdmin user={user} />}

          {active === "settings" && <ParametresAdmin user={user} />}
        </section>
        {confirmLogout && (
  <div className="logoutModalOverlay">
    <div className="logoutModal">
      <div className="logoutModalTitle">Confirmation</div>

      <div className="logoutModalText">
        Voulez-vous vraiment vous déconnecter ?
      </div>

      <div className="logoutModalActions">

        <button
          className="btnSecondary"
          onClick={() => setConfirmLogout(false)}
        >
          Annuler
        </button>

        <button
          className="btnDanger"
          onClick={() => {
            setConfirmLogout(false);
            onLogout();
          }}
        >
          Se déconnecter
        </button>

      </div>
    </div>
  </div>
)}

      </main>

    </div>
  );
};

function AdminOverview({ user }) {
  const [data, setData] = React.useState(null);
  const [loading, setLoading] = React.useState(true);

  React.useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await fetch(
          `${API_BASE}/admin/dashboard-analytics`,
          {
            headers: {
              Authorization: `Bearer ${user.token}`,
            },
          }
        );

        const json = await res.json();
        if (res.ok) setData(json);
      } catch (e) {
        console.log(e);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [user.token]);

  if (loading) return <div>Chargement dashboard...</div>;
  if (!data) return <div>Erreur chargement dashboard</div>;

  const COLORS = {
    "Confirmé": "#2563eb",
    "Annulé": "#dc2626",
  };

  return (
    <div className="adminDashboard">
      <div className="adminKpiGrid">
        <KpiCard
          title="RDV Aujourd'hui"
          value={data.kpi.rdv_today}
          growth={data.kpi.rdv_today_growth}
        />

        <KpiCard
          title="RDV Cette Semaine"
          value={data.kpi.rdv_week}
          growth={data.kpi.rdv_week_growth}
        />

        <KpiCard
          title="Taux Confirmation"
          value={`${data.kpi.confirmation_rate}%`}
        />

        <KpiCard
          title="Taux Annulation"
          value={`${data.kpi.cancel_rate}%`}
        />

        <KpiCard
          title="Nouveaux Utilisateurs (7j)"
          value={data.kpi.new_users}
        />
      </div>

      <div className="adminDashboardRow">
        <div className="dashboardCard">
          <div className="dashboardCardTitle">
            Évolution RDV (7 derniers jours)
          </div>

          <ResponsiveContainer width="100%" height={250}>
            <LineChart data={data.rdv_by_day}>
              <CartesianGrid strokeDasharray="3 3" />
              <XAxis dataKey="date" />
              <YAxis />
              <Tooltip />
              <Line
                type="monotone"
                dataKey="total"
                stroke="#2563eb"
                strokeWidth={3}
              />
            </LineChart>
          </ResponsiveContainer>
        </div>

        <div className="dashboardCard">
          <div className="dashboardCardTitle">Répartition des statuts</div>

          <ResponsiveContainer width="100%" height={250}>
            <PieChart>
              <Pie
                data={data.status_distribution}
                dataKey="value"
                nameKey="name"
                outerRadius={90}
              >
              {data.status_distribution.map((entry, index) => (
                <Cell key={index} fill={COLORS[entry.name] || "#6b7280"} />
              ))}
              </Pie>
              <Tooltip />
              <Legend verticalAlign="bottom" height={36} />
            </PieChart>
          </ResponsiveContainer>
        </div>
      </div>

      <div className="dashboardCard">
        <div className="dashboardCardTitle">Top Médecins (volume RDV)</div>

        <ul className="rankingList">
          {data.top_medecins.map((m, i) => (
            <li key={i}>
              <span>{m.nom}</span>
              <span>{m.total} RDV</span>
            </li>
          ))}
        </ul>
      </div>

      <PendingUsersWidget token={user.token} />
    </div>
  );
}

const ROLE_LABEL = { MEDECIN: "Médecin", GESTIONNAIRE: "Gestionnaire", USAGER: "Usager", SUPER_ADMIN: "Super Admin" };
const ROLE_COLOR = { MEDECIN: "#0e7490", GESTIONNAIRE: "#7c3aed", USAGER: "#065f46", SUPER_ADMIN: "#92400e" };
const ROLE_BG    = { MEDECIN: "#e0f2fe", GESTIONNAIRE: "#ede9fe", USAGER: "#d1fae5", SUPER_ADMIN: "#fef3c7" };

function PendingUsersWidget({ token }) {
  const [users,      setUsers]      = React.useState([]);
  const [loading,    setLoading]    = React.useState(true);
  const [activating, setActivating] = React.useState(null);
  const [confirm,    setConfirm]    = React.useState(null); // user à confirmer

  const load = React.useCallback(() => {
    setLoading(true);
    fetch(`${API_BASE}/admin/pending-users`, {
      headers: { Authorization: `Bearer ${token}` },
    })
      .then(r => r.json())
      .then(d => setUsers(d.items || []))
      .catch(() => {})
      .finally(() => setLoading(false));
  }, [token]);

  React.useEffect(() => { load(); }, [load]);

  React.useEffect(() => {
    window.addEventListener("focus", load);
    return () => window.removeEventListener("focus", load);
  }, [load]);

  const doActivate = async () => {
    if (!confirm) return;
    setActivating(confirm.id);
    setConfirm(null);
    try {
      const url = confirm.role === "USAGER"
        ? `${API_BASE}/admin/usagers/${confirm.id}/actif`
        : `${API_BASE}/admin/utilisateurs/${confirm.id}/actif`;
      const res = await fetch(url, {
        method:  "PATCH",
        headers: { "Content-Type": "application/json", Authorization: `Bearer ${token}` },
        body:    JSON.stringify({ actif: true }),
      });
      if (res.ok) setUsers(prev => prev.filter(u => u.id !== confirm.id));
    } catch {}
    finally { setActivating(null); }
  };

  const fmtDate = (iso) => iso
    ? new Date(iso).toLocaleDateString("fr-FR", { day: "2-digit", month: "short", year: "numeric" })
    : "—";

  return (
    <div className="dashboardCard pendingCard">
      <div className="pendingCardHeader">
        <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
          <div className="dashboardCardTitle" style={{ margin: 0 }}>
            Comptes en attente de validation
          </div>
          {!loading && <span className="pendingBadge">{users.length}</span>}
        </div>
        <button
          className="pendingRefreshBtn"
          onClick={load}
          disabled={loading}
          title="Rafraîchir"
        >
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M23 4v6h-6"/>
            <path d="M1 20v-6h6"/>
            <path d="M3.51 9a9 9 0 0 1 14.85-3.36L23 10M1 14l4.64 4.36A9 9 0 0 0 20.49 15"/>
          </svg>
        </button>
      </div>

      {loading ? (
        <div className="pendingEmpty">Chargement…</div>
      ) : users.length === 0 ? (
        <div className="pendingEmpty">
          <span className="pendingEmptyIcon">✓</span>
          Aucun compte en attente — tout est à jour.
        </div>
      ) : (
        <div className="pendingTable">
          <div className="pendingTableHead">
            <span>Utilisateur</span>
            <span>Rôle</span>
            <span>Inscrit le</span>
            <span />
          </div>
          {users.map(u => (
            <div key={u.id} className="pendingTableRow">
              <div className="pendingUserCell">
                <div className="pendingAvatar">
                  {(u.email || "?")[0].toUpperCase()}
                </div>
                <div className="pendingEmail" style={{ fontWeight: 500, color: "#0f172a" }}>
                  {u.email}
                </div>
              </div>
              <span
                className="pendingRole"
                style={{ background: ROLE_BG[u.role], color: ROLE_COLOR[u.role] }}
              >
                {ROLE_LABEL[u.role] || u.role}
              </span>
              <span className="pendingDate">{fmtDate(u.created_at)}</span>
              <button
                className="pendingActivateBtn"
                disabled={activating === u.id}
                onClick={() => setConfirm(u)}
              >
                {activating === u.id ? "…" : "Activer"}
              </button>
            </div>
          ))}
        </div>
      )}

      {/* Modal de confirmation */}
      {confirm && (
        <div className="logoutModalOverlay">
          <div className="logoutModal">
            <div className="logoutModalTitle">Activer le compte</div>
            <div className="logoutModalText">
              Voulez-vous activer le compte de<br />
              <strong>{confirm.email}</strong> ?
              <br /><br />
              <span style={{ fontSize: 13, color: "#5c6f91" }}>
                Rôle : {ROLE_LABEL[confirm.role] || confirm.role} · Inscrit le {fmtDate(confirm.created_at)}
              </span>
            </div>
            <div className="logoutModalActions">
              <button className="btnSecondary" onClick={() => setConfirm(null)}>
                Annuler
              </button>
              <button className="btnPrimary" onClick={doActivate}>
                Confirmer l'activation
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

function KpiCard({ title, value, growth }) {
  return (
    <div className="kpiCard">
      <div className="kpiTitle">{title}</div>
      <div className="kpiValue">{value}</div>
      {growth !== undefined && (
        <div className={`kpiGrowth ${growth >= 0 ? "up" : "down"}`}>
          {growth >= 0 ? "▲" : "▼"} {Math.abs(growth)}%
        </div>
      )}
    </div>
  );
}

export default DashboardAdmin;